<template>
    <BaseSlideOver
        :model-value="model"
        :title="$t('notifications.title')"
        size="md"
        @update:model-value="model = $event">
        <NotificationFeed />
    </BaseSlideOver>
</template>

<script setup lang="ts">
import type {NotificationAction} from "@/store/notifications"
import {useNotificationStore} from "@/store/notifications"
import {getNotificationAppearance} from "@/utils/notificationAppearance"

const notificationStore = useNotificationStore()
const localePath = useLocalePath()

const openNotificationAction = async (action: NotificationAction) => {
    console.log("opening url", action.url)
    
    await navigateTo(localePath(action.url))
}

// listen for new notifications
useEventBus('notifications').on((notification: any) => {
    notificationStore.refreshTimeline()
    const content = notification?.data?.content ?? notification?.content
    const action = notification?.data?.action ?? notification?.action

    if (!content) {
        return
    }

    const notificationAppearance = getNotificationAppearance(notification?.type)

    if (action?.label && action?.url) {
        useNotification().action(
            content,
            notificationAppearance.icon,
            {
                name: action.label,
                callback: () => {
                    openNotificationAction(action)
                }
            },
            "",
            notificationAppearance.banner.type,
            {
                permanent: notificationAppearance.banner.permanent ?? false
            }
        )
        return
    }

    useNotification().custom(content, notificationAppearance.icon, "", "", notificationAppearance.banner.type, {
        permanent: notificationAppearance.banner.permanent ?? false
    })
})

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    }
})

const emits = defineEmits(['update:modelValue'])

const model = computed({
    get: () => props.modelValue,
    set: (value) => emits('update:modelValue', value)
})
</script>
